// 마이
export const schemeUrl = {
  profile: 'tmap://setting-myinfo',
  point: 'tmap://paypoint',
  biz_place: 'tmap://biz-place',
}

export const envServiceUrl = {
  tmapBizInfo: {
    dev: 'https://tmobi-board-dev.tmapmobility.com/BOARD-STATIC/61',
    stg: 'https://tmobi-board-stg.tmapmobility.com/BOARD-STATIC/90',
    prd: 'https://board.tmapmobility.com/BOARD-STATIC/9',
  },
  pedometerTip: {
    dev: 'tmap://board?pageid=board_detail&boardid=BOARD-MAIN&seq=231',
    stg: 'tmap://board?pageid=board_detail&boardid=BOARD-MAIN&seq=623',
    prd: 'tmap://board?pageid=board_detail&boardid=BOARD-MAIN&seq=378',
  },
  openProfileGuide: {
    dev: 'tmap://board?pageid=board_detail&boardid=BOARD-MAIN&seq=245',
    stg: 'tmap://board?pageid=board_detail&boardid=BOARD-MAIN&seq=768',
    prd: 'tmap://board?pageid=board_detail&boardid=BOARD-MAIN&seq=544',
  },
  restrictionGuide: {
    dev: 'tmap://board?pageid=board_detail&boardid=BOARD-STATIC&seq=257',
    stg: 'tmap://board?pageid=board_detail&boardid=BOARD-STATIC&seq=871',
    prd: 'tmap://board?pageid=board_detail&boardid=BOARD-STATIC&seq=665',
  }
}

export interface VehicleRegisterTextType {
  text: string
  url: string
}

export const staticVehicleRegisterText: VehicleRegisterTextType = {
  text: '차량 등록하고 보험 혜택받기',
  url: 'tmap://biz-place',
}

export const staticPointText = { text: '리뷰쓰고 300P 받기!' }
export const staticMileageText = { text: '첫 이용하고 5% 적립!' }
export const staticDgTourCard = { title: '디지털 관광주민증', isShow: true }
export const staticMission = { title: '오늘의 할 일!', isShow: true }
export const staticStepCounterBanner = {
  normalText: '만보기로 매일',
  boldText: '20P 받기',
  isShow: true,
}

export interface BizPlaceBannerType {
  isShow: boolean
  url: string
}

export const staticBizPlaceBanner: BizPlaceBannerType = { isShow: true, url: 'tmap://biz-place' }

export interface GroupListType {
  name: string
  url: string
  osType?: Array<string>
  redDotItem?: string
  log_action_id?: string
  minVersion?: string
  maxVersion?: string
}

export interface ServiceListType {
  groupName: string
  groupCode: string
  groupList: GroupListType[]
}

export const staticServiceList: ServiceListType[] = [
  {
    groupName: '서비스 모아보기',
    groupCode: 'service_list',
    groupList: [
      {
        name: '전체 서비스',
        url: 'tmap://vertical?service=my&pageid=all_services',
        redDotItem: 'HOME',
        log_action_id: 'tap.whole_service',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '다른시간 출발',
        url: 'tmap://schedule',
        log_action_id: 'tap.timemachine',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '디지털 관광주민증',
        url: 'tmap://vertical?service=dgtourcard',
        redDotItem: 'DGTOURCARD',
        log_action_id: 'tap.dgtourcard',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '장소리뷰',
        url: 'tmap://place?productid=review&pageid=home&portraitonly=true',
        redDotItem: 'REVIEW',
        log_action_id: 'tap.review',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '비즈 플레이스',
        url: 'tmap://biz-place',
        redDotItem: 'BIZ_PLACE',
        log_action_id: 'tap.biz_place',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '연구소',
        url: 'tmap://setting-laboratory',
        redDotItem: 'LABORATORY',
        log_action_id: 'tap.laboratory',
        osType: ['AOS', 'iOS'],
      },
    ],
  },
  {
    groupName: '결제관리',
    groupCode: 'pay_manage',
    groupList: [
      {
        name: '이용내역',
        url: 'tmap://usage-history',
        redDotItem: 'USAGE',
        log_action_id: 'tap.usage',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '결제관리',
        url: 'payment',
        redDotItem: 'PAY',
        log_action_id: 'tap.pay',
        osType: ['AOS', 'iOS'],
      },
    ],
  },
  {
    groupName: '고객지원',
    groupCode: 'customer_support',
    groupList: [
      {
        name: '고객센터',
        url: 'tmap://cs?portraitonly=true',
        redDotItem: 'VOC',
        log_action_id: 'tap.voc',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '공지사항/이벤트',
        url: 'tmap://communication',
        redDotItem: 'COMMUNICATION',
        log_action_id: 'tap.communication_event',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '내비 업데이트 소식',
        url: 'tmap://board?pageid=board_list&boardid=BOARD-NAVIGATION-UPDATE-V2',
        redDotItem: 'NAVIGATION_UPDATE',
        log_action_id: 'tap.navigation_update',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '장소 등록/수정',
        url: 'tmap://tip-off',
        redDotItem: 'POI_SUGGESTION',
        log_action_id: 'tap.poi_proposal',
        osType: ['AOS', 'iOS'],
      },
      {
        name: '약관',
        url: 'tmap://webview?service=policy&id=1&params=termsCode%3DLIST-TERMS-TMAP-MAIN%26appCode%3DTMAP%26headerYn%3Dy%26headerTitle%3D%EC%9D%B4%EC%9A%A9%EC%95%BD%EA%B4%80',
        redDotItem: 'POLICY',
        log_action_id: 'tap.policy',
        osType: ['AOS', 'iOS'],
      },
    ],
  },
]

export interface InsuranceBannerType {
  bodyText: string
  btnText: string
  subText: string
  url: string
}

export const staticInsuranceBanner: InsuranceBannerType = {
  bodyText: '자동차 보험이 곧 만료되나요?',
  btnText: '내 운전점수로 할인율 비교하기',
  subText: '* 내 차 등록일 기준',
  url: 'tmap://tscore?pageid=benefit&extra=%7b%22is_first_history%22%3atrue%2c%22logbox%22%3a%7b%22origin%22%3a%22my%22%2c%22type%22%3a%22banner%22%7d%2c%22targetScheme%22%3a%22tscore%22%7d&top=true',
}

export interface TooltipMessageType {
  item: string
  startDateTime: string
  endDateTime: string
  order: number
  message: string
}

export const staticTooltipMessage: TooltipMessageType[] = [
  {
    item: 'POINT',
    startDateTime: '20250811120000',
    endDateTime: '20250826120000',
    order: 1,
    message: '포인트 샵이 오픈했어요',
  },
  {
    item: 'DGTOURCARD',
    startDateTime: '20250811120000',
    endDateTime: '20250826120000',
    order: 2,
    message: '국내여행 할인받기',
  },
  {
    item: 'PROFILE',
    startDateTime: '',
    endDateTime: '',
    order: 1,
    message: '프로필을 설정하고 나를 표현해보세요!',
  },
]

// 만보기
export interface StepCounterInsuranceBannerType {
  imgUrl: string
  title: string
  subText: string
  landingUrl: string
}

export const staticStepCounterInsuranceBanner: StepCounterInsuranceBannerType[] = [
  {
    imgUrl: 'https://cdn-dev.tmobiweb.com/common/mission/10000.png',
    title: '만보기로 보험료 추가 할인 가능',
    subText: '자세히 보기 ',
    landingUrl: 'tmap://board?pageid=board_detail&boardid=BOARD-MAIN&seq=623',
  },
]
